<ng-container *ngIf="ready == false">
  <br />
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
  <convfact-preinvoice-form [active]="active" [preinvoice]="preinvoice" [accountsAndTaxes]="accountsAndTaxes"
    [edit]="edit" [bankAccounts]="bankAccounts" *ngIf="preinvoice" [errors]="errors" (onSave)="saveData($event)">
  </convfact-preinvoice-form>
</ng-container>